// import { firebase } from '../lib/db';
import { cleanFirebaseId, serverApiEurope } from '../lib/utils';
import { createReviewId } from '../lib/reviewUtils';
import { tokenFetch } from '../lib/tokenUtils';
import { logLikeReview } from '../lib/analyticsEvents';
import {
    ADD_LIKES_REVIEWS, REMOVE_LIKES_REVIEWS, ADD_REPORTED_REVIEWS, REMOVE_REPORTED_REVIEWS
}
    from './types';
import { arrayUnion, arrayRemove } from "firebase/firestore/lite";

export const toggleLikeReview = (userUID, reviewId, type = 'like') => async dispatch => { // episodeId + '_userId_' + userUID;

    // let modifyReviewLikes;
    let firestoreUpdate = {};
    let url = `${serverApiEurope}toggleLikeReview?reviewId=${reviewId}`;
    // let url = `http://localhost:5000/podcastapp-767c2/europe-west1/toggleLikeReview?reviewId=${reviewId}`;
    if (type === 'like') {
        url += '&type=like';
        dispatch({
            type: ADD_LIKES_REVIEWS,
            reviewId: reviewId,
            userUID: userUID
        })
        firestoreUpdate['likesArray'] = arrayUnion(userUID);
        logLikeReview(reviewId, 1);
    } else {
        url += '&type=unlike';
        dispatch({
            type: REMOVE_LIKES_REVIEWS,
            reviewId: reviewId,
            userUID: userUID
        })
        firestoreUpdate['likesArray'] = arrayRemove(userUID);
        logLikeReview(reviewId, 0);
    }

    tokenFetch(url)
        .then((data) => {
            // return ({ success: true });
            console.log(data);
        })
        .catch((error) => {
            console.error("Error adding document: ", error);
        });
}

export const toggleReportReview = (userUID, reviewId, type = 'report') => async dispatch => { // episodeId + '_userId_' + userUID;

    // let modifyReviewLikes;
    let firestoreUpdate = {};
    let url = `${serverApiEurope}toggleReportReview?reviewId=${reviewId}`;
    // let url = `http://localhost:5000/podcastapp-767c2/europe-west1/toggleReportReview?reviewId=${reviewId}`;
    if (type === 'report') {
        url += '&type=report';
        dispatch({
            type: ADD_REPORTED_REVIEWS,
            reviewId: reviewId,
            userUID: userUID
        })
        firestoreUpdate['reportedArray'] = arrayUnion(userUID);
    } else {
        url += '&type=unreport';
        dispatch({
            type: REMOVE_REPORTED_REVIEWS,
            reviewId: reviewId,
            userUID: userUID
        })
        firestoreUpdate['reportedArray'] = arrayRemove(userUID);
    }

    tokenFetch(url)
        .then((data) => {
            // return ({ success: true });
            console.log(data);
        })
        .catch((error) => {
            console.error("Error adding document: ", error);
        });
}